import { ISchedulerSalonResData } from 'services/types/response';
import { createAction, createAsyncAction } from 'store/actionConfigs';
import { ICustomerUI } from 'types/customer';
import { IServiceUI } from 'types/service';
import { IStaffUI } from 'types/staff';
import { IBlockHourHistoriesQuery, IBlockHourHistoriesResponse, IBlockHourResItem, ITimeOffListQuery } from 'services/types/blockHours';
import { IShopAllSetting } from 'services/types/shop';
import { IBodyCreateStaffGroup, IBodyUpdateStaffGroup, IStaffGroupAssignment } from 'services/types/staff-group';
import { IStaffGroupUI } from 'types/staff-group';

const PREFIX_ACTIONS = 'shop_feature_';

const afterCreateCustomer = createAction<ICustomerUI>(PREFIX_ACTIONS + 'afterCreateCustomer');
const afterUpdateCustomer = createAction<ICustomerUI>(PREFIX_ACTIONS + 'afterUpdateCustomer');
const afterCreateService = createAction<IServiceUI>(PREFIX_ACTIONS + 'afterCreateService');

const shopActions = {
  staff: createAsyncAction(PREFIX_ACTIONS + 'getStaffs'),
  pureStaffs: createAsyncAction<string>(PREFIX_ACTIONS + 'pureStaffs'),
  staffAvailable: createAsyncAction<string, IStaffUI[]>(PREFIX_ACTIONS + 'getStaffsAvailable'),
  blockHourHistories: createAsyncAction<IBlockHourHistoriesQuery, IBlockHourHistoriesResponse>(PREFIX_ACTIONS + 'getBlockHourHistories'),
  timeOffList: createAsyncAction<ITimeOffListQuery, IBlockHourResItem[]>(PREFIX_ACTIONS + 'getTimeOffList'),
  scheduleTimeOffSlots: createAsyncAction<{ date?: string; staffId?: string }, string[]>(PREFIX_ACTIONS + 'getScheduleTimeOffSlots'),
  category: createAsyncAction<string>(PREFIX_ACTIONS + 'category'),
  customer: createAsyncAction<string>(PREFIX_ACTIONS + 'customer'),
  scheduler: createAsyncAction<undefined, ISchedulerSalonResData>(PREFIX_ACTIONS + 'scheduler'),
  afterCreateCustomer,
  afterUpdateCustomer,
  afterCreateService,
  salonInfo: createAsyncAction<string>(PREFIX_ACTIONS + 'getSalonInfo'),
  // Shop-wide feature flags from GET /api/v1/shop/all-setting; fetch payload = shopId.
  shopAllSetting: createAsyncAction<string, IShopAllSetting>(PREFIX_ACTIONS + 'getShopAllSetting'),
  clockInStaffs: createAsyncAction(PREFIX_ACTIONS + 'getClockInStaffs'),
  // Staff groups: display grouping that colors the day-view calendar header.
  staffGroups: createAsyncAction<undefined, IStaffGroupUI[]>(PREFIX_ACTIONS + 'getStaffGroups'),
  createStaffGroup: createAction<IBodyCreateStaffGroup>(PREFIX_ACTIONS + 'createStaffGroup'),
  updateStaffGroup: createAction<{ id: string } & IBodyUpdateStaffGroup>(PREFIX_ACTIONS + 'updateStaffGroup'),
  deleteStaffGroup: createAction<string>(PREFIX_ACTIONS + 'deleteStaffGroup'),
  assignStaffGroups: createAction<IStaffGroupAssignment[]>(PREFIX_ACTIONS + 'assignStaffGroups'),
};

export default shopActions;

